import 'slick-carousel'
import 'slick-lightbox'
import '@js/custom/parallaxie'
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js'
import Plyr from 'plyr'
import Cookies from 'js-cookie'
import moment from 'moment'
import Lenis from 'lenis'
import Rellax from 'rellax'

const leftArrow
    = '<button type="button" class="slick-prev"><svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9087 7.29175L1.50781 7.29175" stroke="white" stroke-linecap="square" stroke-linejoin="round"/><path d="M7.10708 13.3093L1.08984 7.29209L7.10708 1.27486" stroke="white" stroke-linecap="square" stroke-linejoin="round"/></svg></button>'
const rightArrow
    = '<button type="button" class="slick-next"><svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.09127 7.70825L12.4922 7.70825" stroke="white" stroke-linecap="square" stroke-linejoin="round"/><path d="M6.89292 1.69067L12.9102 7.70791L6.89292 13.7251" stroke="white" stroke-linecap="square" stroke-linejoin="round"/></svg></button>'
const facebook
    = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg>'
const instagram
    = '<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><pathd="M15.815 13.7259C15.815 15.0809 14.7166 16.1793 13.3616 16.1793C12.0066 16.1793 10.9082 15.0809 10.9082 13.7259C10.9082 12.3709 12.0066 11.2725 13.3616 11.2725C14.7166 11.2725 15.815 12.3709 15.815 13.7259Z"fill="#00AEEF" /><pathd="M19.1 9.38556C18.9821 9.06598 18.7939 8.77671 18.5494 8.53927C18.312 8.29478 18.0229 8.10663 17.7031 7.98869C17.4438 7.88797 17.0542 7.76807 16.3366 7.73541C15.5603 7.70001 15.3275 7.69238 13.3623 7.69238C11.3969 7.69238 11.1641 7.69982 10.3881 7.73522C9.67045 7.76807 9.28065 7.88797 9.0215 7.98869C8.70172 8.10663 8.41245 8.29478 8.1752 8.53927C7.93072 8.77671 7.74257 9.06578 7.62444 9.38556C7.52371 9.64491 7.40382 10.0347 7.37115 10.7523C7.33575 11.5284 7.32812 11.7611 7.32812 13.7266C7.32812 15.6918 7.33575 15.9246 7.37115 16.7008C7.40382 17.4184 7.52371 17.808 7.62444 18.0674C7.74257 18.3872 7.93053 18.6762 8.17501 18.9137C8.41245 19.1582 8.70152 19.3463 9.0213 19.4642C9.28065 19.5652 9.67045 19.6851 10.3881 19.7177C11.1641 19.7531 11.3967 19.7606 13.3621 19.7606C15.3277 19.7606 15.5605 19.7531 16.3364 19.7177C17.054 19.6851 17.4438 19.5652 17.7031 19.4642C18.345 19.2166 18.8524 18.7093 19.1 18.0674C19.2007 17.808 19.3206 17.4184 19.3535 16.7008C19.3889 15.9246 19.3963 15.6918 19.3963 13.7266C19.3963 11.7611 19.3889 11.5284 19.3535 10.7523C19.3208 10.0347 19.2009 9.64491 19.1 9.38556V9.38556ZM13.3623 17.5059C11.2748 17.5059 9.58263 15.8139 9.58263 13.7264C9.58263 11.6389 11.2748 9.94689 13.3623 9.94689C15.4496 9.94689 17.1418 11.6389 17.1418 13.7264C17.1418 15.8139 15.4496 17.5059 13.3623 17.5059ZM17.2912 10.6807C16.8034 10.6807 16.408 10.2853 16.408 9.79746C16.408 9.30967 16.8034 8.9142 17.2912 8.9142C17.779 8.9142 18.1745 9.30967 18.1745 9.79746C18.1743 10.2853 17.779 10.6807 17.2912 10.6807Z"fill="#00AEEF" /><pathd="M13.3608 0.908203C6.2828 0.908203 0.542969 6.64803 0.542969 13.7261C0.542969 20.8041 6.2828 26.5439 13.3608 26.5439C20.4388 26.5439 26.1787 20.8041 26.1787 13.7261C26.1787 6.64803 20.4388 0.908203 13.3608 0.908203ZM20.6767 16.7606C20.6411 17.5441 20.5165 18.079 20.3346 18.5472C19.9522 19.5359 19.1707 20.3175 18.182 20.6998C17.714 20.8817 17.1788 21.0061 16.3955 21.0419C15.6106 21.0777 15.3599 21.0863 13.361 21.0863C11.3619 21.0863 11.1114 21.0777 10.3263 21.0419C9.543 21.0061 9.00788 20.8817 8.53985 20.6998C8.04854 20.515 7.60378 20.2253 7.23608 19.8508C6.86173 19.4833 6.57207 19.0383 6.38724 18.5472C6.20535 18.0792 6.08076 17.5441 6.04516 16.7608C6.00898 15.9757 6.00057 15.7249 6.00057 13.7261C6.00057 11.7272 6.00898 11.4764 6.04497 10.6916C6.08056 9.90804 6.20496 9.37312 6.38685 8.90489C6.57168 8.41377 6.86153 7.96882 7.23608 7.60131C7.60358 7.22677 8.04854 6.93711 8.53965 6.75228C9.00788 6.57039 9.54281 6.44599 10.3263 6.4102C11.1112 6.37441 11.3619 6.3658 13.3608 6.3658C15.3597 6.3658 15.6104 6.37441 16.3953 6.4104C17.1788 6.44599 17.7138 6.57039 18.182 6.75208C18.6731 6.93691 19.1181 7.22677 19.4858 7.60131C19.8601 7.96901 20.15 8.41377 20.3346 8.90489C20.5167 9.37312 20.6411 9.90804 20.6769 10.6916C20.7127 11.4764 20.7211 11.7272 20.7211 13.7261C20.7211 15.7249 20.7127 15.9757 20.6767 16.7606V16.7606Z"fill="#00AEEF" /></svg>'

const digistormWeb = {
    init() {
        // helper for iOS issues
        this.iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        this.nav()
        this.tabs()
        this.accordions()
        this.videos.init()
        this.gallery()
        // this.banners()
        this.video_modal()
        this.forms()
        this.popups()
        this.analytics()
        this.employment()
        this.newsletters()
        this.entryScreen()
        this.socialFeeds()
        this.newsletterBackToTop()
        this.wowo()
        this.stickyMenu()
        this.navbar()
        this.search()
        this.entryCalculator()
        this.userback()
    },
    nav() {
        // $('.parent-item.has-child .parent-title').after('<span class="view-child"></span>');
        $('.parent-item .parent-title').bind(' focus mouseenter ', function (e) {
            if ($(window).width() > 1023) {
                e.preventDefault()
                const parent = $(this).closest('.parent-item')
                // const parent = $(this)
                parent.addClass('is-active').siblings('.parent-item').removeClass('is-active')
                // parent.find('.child-panel').attr('aria-hidden', 'false');
                // parent.siblings().find('.child-panel').attr('aria-hidden', 'true');
            }
        })
        $('.level1').bind(' focus mouseenter keydown', function (e) {
            if ($(window).width() > 1023) {
                $(this).addClass('is-active')
            }
        })

        $('.parent-item.has-children').on('click', function (e) {
            if ($(window).width() <= 1023) {
                const parent = $(this)
                parent.toggleClass('is-active').siblings('.parent-item').removeClass('is-active')
            }
        })

        $('.child-item.has-third .child-title').after('<span class="view-third"></span>')
        $('.child-item.has-third').on('click', function (e) {
            const parent = $(this)
            const dropdown = parent.find('.third-panel')
            parent.toggleClass('is-active').siblings('.child-item').removeClass('is-active')
            $('.level2').toggleClass('is-active')
        })
        $('.child-item.has-third .child-title').on('click', (e) => {
            e.preventDefault()
        })

        $('.level3 .third-title').on('click', (e) => {
            e.stopPropagation()
        })
    },
    tabs() {
        $('.tabs')
            .find('.tabs-title')
            .click(function () {
                const $tabs = $(this).closest('.tabs')
                const activeIndex = $(this).index()

                $tabs.find('.tabs-title').removeClass('is-active')
                $tabs.find('.tabs-content').removeClass('is-active')

                $(this).addClass('is-active')
                $tabs.find('.tabs-content').eq(activeIndex).addClass('is-active')
            })
    },
    accordions() {
        $('.accordion')
            .find('.accordion-header')
            .on('click', function () {
                const $wrapper = $(this).closest('.accordion-wrapper')
                const $content = $(this).next('.accordion-content')
                const $wasActive = $wrapper.hasClass('is-active')
                const $otherWrapper = $wrapper.siblings()
                if ($wasActive) {
                    $wrapper.removeClass('is-active')
                    $content.stop().slideUp(250)
                } else {
                    $wrapper.addClass('is-active')
                    $content.stop().slideDown(250)
                    $otherWrapper.removeClass('is-active').find('.accordion-content').slideUp(250)
                }
            })
    },
    videos: {
        init() {
            const _self = this

            // check if there is a video player wrapper

            if ($('.video-player.banner-video').length) {
                $('.video-player.banner-video').each(function () {
                    _self.loadVideo(this)
                })
            }

            _self.controls()
            _self.carousel()
        },

        controls() {
            // initialise video controls

            $('.video-carousel .banner .control-pause').click(function () {
                const $player = $(this).closest('.banner').find('.video-player')
                switch (digistormWeb.videos.togglePlay($player)) {
                    case 'no-data':
                        break
                    case true:
                        $(this).removeClass('fa-play').addClass('fa-pause')
                        break
                    case false:
                        $(this).removeClass('fa-pause').addClass('fa-play')
                        break
                }
            })

            $('.video-carousel .banner .control-vol').click(function () {
                const $player = $(this).closest('.banner').find('.video-player')
                switch (digistormWeb.videos.toggleMute($player)) {
                    case 'no-data':
                        break
                    case true:
                        $(this).removeClass('fa-volume-off').addClass('fa-volume-up')
                        break
                    case false:
                        $(this).removeClass('fa-volume-up').addClass('fa-volume-off')
                        break
                }
            })
        },

        carousel() {
            // handle videos inside slick carousels
            $('.video-carousel')
                .on('init', (event, slick) => {
                    // mark carousel as initialized
                    slick.is_initialized = true
                })
                .on('setPosition', (event, slick) => {
                    // synchronize slides with videos

                    if (slick.is_initialized) {
                        // the slide up next
                        const $newSlide = $(slick.$slides[slick.currentSlide])

                        // pause others
                        $newSlide
                            .closest('.video-carousel')
                            .find('.banner')
                            .not($newSlide)
                            .find('.video-player')
                            .each((i, e) => {
                                if (digistormWeb.iOS) {
                                    // currently there's a bug with plyr where pause won't work on iOS
                                    digistormWeb.videos.stopVideo($(e))
                                } else {
                                    digistormWeb.videos.pauseVideo($(e))
                                }
                            })

                        // play new slide
                        const video = $newSlide.find('.video-player')
                        digistormWeb.videos.playVideo(video)
                        if (video.data() && video.data().player) {
                            // This slide is a video, pause slick autoslide
                            slick.$slider.slick('slickPause')
                        } else {
                            // This slide is not a video, resume slick autoslide
                            slick.$slider.slick('slickPlay')
                            $('.circleProgress').css('animation-duration', `${5.9}s`)
                        }
                    }
                })
        },

        loadVideo(el) {
            // load a video element

            // get each config attr from this element
            const settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            const player = $(el).find('.player')
            const plyr = new Plyr(player[0], settings)
            // set up each video
            $(el).data({
                player: plyr,
            })

            // if a carousel video, go to the next slide on video end
            const $carousel = $(el).closest('.video-carousel')
            if ($carousel.length) {
                if (plyr.source && plyr.source.indexOf('youtube') >= 0) {
                    // youtube loop doesn't work, manually detect end of video
                    plyr.on('timeupdate', (event) => {
                        if (plyr.currentTime >= plyr.duration - 0.1) {
                            plyr.restart()
                            if ($carousel.find('.banner').length > 1) {
                                $carousel.slick('slickNext')
                            }
                        }
                    })
                } else {
                    // on loop, go to the next slide
                    plyr.on('seeked', (event) => {
                        $carousel.slick('slickNext')
                    })
                }

                plyr.on('playing', () => {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play')
                        .addClass('fa-pause')
                })
                plyr.on('pause', () => {
                    $(el).closest('.banner').find('.control-pause').removeClass('fa-play')
                        .addClass('fa-pause')
                })
            }

            if (settings.muted && settings.autoplay) {
                digistormWeb.videos.attemptPlay(plyr)
            }
        },

        loadVideoModal(el) {
            // console.log("loading video now");

            // get each config attr from this element
            const settings = JSON.parse($(el).attr('data-settings'))

            // grab player elements
            const player = $(el).find('.player')

            const plyr = new Plyr(player[0], settings)

            // set up each video
            $(el).data({
                player: plyr,
            })

            digistormWeb.videos.attemptPlay(plyr, settings.volume, settings.muted)

            $(el).addClass('plyr-loaded')
        },

        attemptPlay(player, volume = 0, muted = true, count = 0) {
            // attempts to play the video multiple times in case element is still loading

            player.volume = volume
            player.muted = muted
            player.play()
            if (count < 15 && !player.playing) {
                setTimeout(() => {
                    count++
                    digistormWeb.videos.attemptPlay(player, volume, muted, count)
                }, 1000)
            }
        },

        playVideo($el, volume = 0, muted = 1) {
            if ($el.data() && $el.data().player) {
                // enable ability to play unmuted
                $el.data().player.volume = volume
                $el.data().player.muted = muted
                $el.data().player.play()
            }
        },
        pauseVideo($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.pause()
            }
        },
        stopVideo($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.stop()
            }
        },
        togglePlay($el) {
            if ($el.data() && $el.data().player) {
                $el.data().player.togglePlay()
                return $el.data().player.playing
            }
            return 'no-data'
        },
        toggleMute($el) {
            if ($el.data() && $el.data().player) {
                const player = $el.data().player
                if (player.volume === 0) {
                    player.volume = 1
                    return true
                }
                player.volume = 0
                return false
            }
            return 'no-data'
        },
    },
    gallery() {
        const galleryLightbox = $('.gallery')
            .find('ul')
            .slickLightbox({
                itemSelector: '> li > a',
                caption: 'caption',
                layouts: {
                    closeButton:
                        '<button class="close-modal slick-lightbox-close close-button"> <span></span> <span></span> <span></span> </button>',
                },
            })
        galleryLightbox.on({
            'show.slickLightbox': function () {
                digistormWeb.lockBg()
            },
            'shown.slickLightbox': function () {
                // fired when the lightbox is opened, after the transitions took place
            },
            'hide.slickLightbox': function () {
                // fired when the lightbox is closed
                digistormWeb.unlockBg()
            },
            'hidden.slickLightbox': function () {
                // fired when the lightbox is closed, after the transitions took place
            },
        })

        $('.gallery .more-s').click(function (e) {
            e.preventDefault()
            $(this).closest('.gallery').find('.is-hidden:first a').click()
        })
    },
    banners() {
        const banner = $('.image-carousel .slick-content')
        if (banner.length > 0) {
            banner.slick({
                dots: banner.find('.banner-inner').length > 1,
                arrows: false,
                infinite: true, // loop
                speed: 800,
                slidesToShow: 1,
                slidesToScroll: 1,
                // autoplay: true,
                // autoplaySpeed: 6000,

                focusOnSelect: true,
                pauseOnHover: false, // mouse hover
                lazyLoad: 'anticipated',
            })
            banner.removeClass('init')
        }
    },
    video_modal() {
        $('.play-video-btn').on('click', function (e) {
            e.preventDefault()
            const modalId = $(this).attr('data-modal-id')
            const modal = $(`#${modalId}`)

            if (!modal) {
                return
            }

            const videoPlayer = modal.find('.video-player')
            if (!videoPlayer) {
                return
            }

            if (!videoPlayer.hasClass('plyr-loaded')) {
                digistormWeb.videos.loadVideoModal(videoPlayer[0])
            } else {
                const settings = JSON.parse(videoPlayer.attr('data-settings'))
                digistormWeb.videos.playVideo(videoPlayer, settings.volume, settings.muted)
            }

            modal.addClass('is-active')
        })

        $('.video-modal .modal-background').click(function () {
            const $modal = $(this).closest('.video-modal')
            $modal.removeClass('is-active')
            if (digistormWeb.iOS) {
                digistormWeb.videos.stopVideo($modal.find('.video-player'))
            } else {
                digistormWeb.videos.pauseVideo($modal.find('.video-player'))
            }
        })

        $('.video-modal .close-button').click(function (e) {
            e.preventDefault()
            const $modal = $(this).closest('.video-modal')
            $modal.removeClass('is-active')
            digistormWeb.videos.stopVideo($modal.find('.video-player'))
        })
    },
    forms() {
        // Send google analytics event on form submission
        $('[data-form-name] form').submit(function () {
            const formWrapper = $(this).closest('[data-form-name]')
            if (window.ga) {
                ga('send', 'event', formWrapper.attr('data-form-name'), formWrapper.attr('data-form-page'))
            }
        })
    },
    popups() {
        $('.action-modal').each(function () {
            const modal = $(this)
            const key = `modal-${modal.data('key')}`
            const cookie = Cookies.get(key)

            if (!cookie) {
                modal.addClass('active')
                setTimeout(() => {
                    $('#ds-vue-wrapper').addClass('action-modal-active')
                }, 1000)

                modal.find('.close-action-modal,.action-modal-background').click(() => {
                    modal.addClass('delete')
                    modal.removeClass('active')
                    $('#ds-vue-wrapper').removeClass('action-modal-active')
                    Cookies.set(key, 'viewed', {
                        expires: 5,
                    })
                })
            }
        })
    },
    analytics() {
        // Track clicks on external links
        $('body').on('click', 'a[href]', function (e) {
            const domain = String(window.location.host).replace(/^www\./, '')
            const openInNewWindow = $(this).attr('target') === '_blank'
            const url = $(this).attr('href')

            // Find the domain of the link. Works with http, https and protocol-less urls
            const linkAnatomy = url.match(/^(https?:)?\/\/(www\.)?([^/\s]+)/)
            if (linkAnatomy) {
                const linkDomain = linkAnatomy[3]

                // Check if google analytics is loaded and the url is external
                if (window.ga && domain !== linkDomain) {
                    ga('send', 'event', 'Navigation', 'Open URL', url)

                    // If the link will open in this window we should delay navigation until the event is sent
                    if (!openInNewWindow && !e.isDefaultPrevented()) {
                        e.preventDefault()

                        // Push the navigation onto the queue (will be processed after event is sent)
                        ga(() => {
                            // Navigate to url
                            window.location.href = url
                        })

                        return false
                    }
                }
            }
        })
    },
    employment() {
        $('.application-form').each((i, e) => {
            const $form = $(e)
            const jobTitle = $form.data('job-title')
            $form.find('input.positionAppliedFor').val(jobTitle)
        })
    },
    newsletters() {
        // Newsletter section

        $('.newsletter-article')
            .find('.continue')
            .on('click', function (e) {
                const $article = $(this).parent()
                const $expandable = $article.find('.newsletter-blocks-wrapper')
                const $content = $article.find('.newsletter-blocks')

                // toggle class
                $article.toggleClass('is-active')

                // set height to article size
                const height = $content.outerHeight() + 20
                $expandable.css({
                    'max-height': `${height}px`,
                })

                if ($article.hasClass('is-active')) {
                    // allow any height after animation done
                    setTimeout(() => {
                        if ($article.hasClass('is-active')) {
                            $expandable.css({
                                'max-height': 'none',
                            })
                        }
                    }, 300)
                } else {
                    // if collapsing article set max height
                    setTimeout(() => {
                        if (!$article.hasClass('is-active')) {
                            $expandable.css({
                                'max-height': '0',
                            })
                        }
                    }, 100)
                }
            })

        $('.newsletter-sidebar #newsletter-menu').on('click', function (e) {
            const menuparent = $(this).closest('.newsletter-sidebar')
            if (!menuparent.hasClass('is-active')) {
                menuparent.addClass('is-active')
            } else {
                menuparent.removeClass('is-active')
            }
        })

        $('.newsletter-sidebar .category-heading').click(function () {
            const target = $($(this).attr('data-attr'))
            $('html, body').animate(
                {
                    scrollTop: target.offset().top - 200,
                },
                800,
            )
            const windowWidth = $(window).width()
            if (windowWidth < 1023) {
                $('.toggle-nav-newsletter').toggleClass('cross')
                $('.newsletter-sidebar').toggleClass('open-sidenav')
            }
        })
    },
    entryScreen() {
        const es = $('.entry-screen')
        const btn = $('.entry-screen #entry-screen-btn')
        const key = 'entryScreen'

        const cookie = Cookies.get(key)

        if (!cookie) {
            es.addClass('active')
            btn.on('click', () => {
                Cookies.set(key, 'viewed', {
                    expires: 1,
                })

                es.removeClass('active')
            })
        }
    },
    socialFeeds() {
        $('section.social-block').each(function () {
            // console.log("requesting social posts...");
            const socialWrapper = $(this).find('.social-wrapper')
            //   this is the toggle for individual social blocks
            const facebookToggle = $(this).attr('data-facebook') === '1'
            const instagramToggle = $(this).attr('data-instagram') === '1'
            const limit = 18

            const svgMap = {
                facebook,
                instagram,
            }

            $.ajax({
                url: '/api/socialfeed/request-posts',
                data: {
                    facebook: facebookToggle,
                    instagram: instagramToggle,
                    limit,
                },
                dataType: 'json',
                success(posts) {
                    if (posts) {
                        let postHtml = ''
                        $.each(posts, (index, post) => {
                            const postDescription
                                = post.description.length > 200
                                    ? `${post.description.substring(0, 199).trim()}...`
                                    : post.description
                            const date = new Date(post.created * 1000).toLocaleDateString()

                            let iconSvg = ''
                            if (post.type in svgMap) {
                                iconSvg = svgMap[post.type]
                            }

                            const html = `<a href="${post.link}" class="item card-overlay" target="_blank"><div class="img"><div class="responsive-img"><img src="${post.image}" alt="" /></div></div><div class="overlay"><div class="lower"><div class="text"><span class="social-icon">${iconSvg}</span><p>${postDescription}</p></div></div></div></a>`

                            postHtml += html
                        })

                        // render posts on page
                        socialWrapper.html(postHtml)

                        socialWrapper.slick({
                            dots: false,
                            arrows: true,
                            prevArrow: leftArrow,
                            nextArrow: rightArrow,
                            infinite: true,
                            speed: 500,
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            autoplay: false,
                            adaptiveHeight: false,
                            fade: false,
                            autoplaySpeed: 5000,
                            pauseOnHover: false,
                            pauseOnFocus: false,
                            focusOnSelect: false,
                            draggable: true,
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                    },
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                    },
                                },
                            ],
                        })
                    }
                },
            }).fail(() => {
                console.log('...failed fetching social posts')
                socialWrapper
                    .find('.socials-loading')
                    .html('<h5>Something went wrong when fetching social feed.<br>Please try again later!</h5>')
            })
        })
    },
    newsletterBackToTop() {
        $('.back-top a').on('click', () => {
            const top = $('#newsletter-wrapper').offset().top - $(window).width() > 575 ? 94 : 58
            window.lenis.scrollTo(top, { duration: 2.2 })
        })
    },
    entryCalculator() {
        function calculateEnrol(birthYear, birthMonth) {
            // QLD kids start Pre prep at 4 years old, so add 4 to the year they were born
            let startYear = birthYear + 4
            const yearLevels = [
                'Pre Prep',
                'Prep',
                'Year 1',
                'Year 2',
                'Year 3',
                'Year 4',
                'Year 5',
                'Year 6',
                'Year 7',
                'Year 8',
                'Year 9',
                'Year 10',
                'Year 11',
                'Year 12',
            ]
            // students born after june get pushed forward a year
            if (birthMonth > 6) {
                startYear++
            }
            const $resultsContainer = $('.child-results')
            const $resultsTable = $resultsContainer.find('table')
            let resultsHtml = '<tr><th>Year of Entry</th><th>Year</th></tr>'
            for (let i = 0; i < yearLevels.length; i++) {
                if (
                    yearLevels[i] === 'Pre Prep'
                    || yearLevels[i] === 'Year 4'
                    || yearLevels[i] === 'Year 7'
                    || yearLevels[i] === 'Year 10'
                ) {
                    resultsHtml = `${resultsHtml}<tr><td>${startYear}</td><td>${yearLevels[i]}</td>`
                }
                startYear++
            }
            // clear table and render results
            $resultsContainer.show()
            $resultsTable.html('').append(resultsHtml)
        }
        // init datepicker
        const $datepicker = $('.input-group.date')
        $datepicker.datepicker({
            container: '.picker-container',
            startDate: `01/01/${new Date().getFullYear() - 15}`,
            startView: '2',
            autoclose: true,
            todayHighlight: true,
            format: 'dd/mm/yyyy',
        })
        // listen for datepicker change
        $datepicker.datepicker().on('changeDate', (e) => {
            const childBirthday = moment($datepicker.datepicker('getDate'))
            calculateEnrol(childBirthday.year(), childBirthday.month() + 1)
        })
    },
    wowo() {
        const wTop = $(window).scrollTop()
        const wHeight = $(window).height()
        const wBottom = wTop + wHeight
        $('.wowo:not(.animated)').each(function () {
            const me = $(this)
            const meTop = me.offset().top
            const meHeight = me.innerHeight()
            const meBottom = meTop + meHeight
            const limitTop = wTop - meHeight
            const limitBottom = wBottom + meHeight
            if (meTop > limitTop && meBottom < limitBottom) {
                me.addClass('animated')
                setTimeout(() => {
                    me.removeClass('wowo')
                }, 1500)
            }
        })
        $('.stretchLine:not(.animated)').each(function () {
            const me = $(this)
            const meTop = me.offset().top
            const meHeight = me.innerHeight()
            const meBottom = meTop + meHeight
            const limitTop = wTop - meHeight
            const limitBottom = wBottom + meHeight
            if (meTop > limitTop && meBottom < limitBottom) {
                me.addClass('animated')
                setTimeout(() => {
                    me.removeClass('wowo')
                }, 2000)
            }
        })
    },
    stickyMenu() {
        if ($('.navigation').length) {
            const { body } = document
            const nav = document.querySelector('.navigation')
            const scrollUp = 'menu-stuck'
            const scrollUpNav = 'is-stuck'
            const scrollDown = 'scroll-down'
            let lastScroll = 0

            let width = $(document).width()
            let navOffset = 95

            window.addEventListener('resize', () => {
                width = $(window).width()
            })

            window.addEventListener('scroll', () => {
                const currentScroll = window.pageYOffset
                const scrollLimit = 0
                const scrollValue = window.scrollY

                if ($('body').hasClass('autoscroll')) {
                    return
                }

                if (width <= 1023) {
                    navOffset = 81
                } else if (width < 1215) {
                    navOffset = 120
                } else {
                    navOffset = 120
                }

                // console.log({scrollValue, lastScroll, width, currentScroll, navOffset})

                if (scrollValue >= scrollLimit) {
                    if (currentScroll <= navOffset) {
                        body.classList.remove(scrollUp)
                        body.classList.remove(scrollDown)
                        nav.classList.remove(scrollUpNav)
                        return
                    }
                    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                        // down
                        body.classList.remove(scrollUp)
                        nav.classList.remove(scrollUpNav)
                        body.classList.add(scrollDown)
                    } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
                        // up
                        body.classList.remove(scrollDown)
                        body.classList.add(scrollUp)
                        nav.classList.add(scrollUpNav)
                    }
                    lastScroll = currentScroll
                }
            })
            window.addEventListener('load', () => {
                const currentScroll = window.pageYOffset
                const scrollLimit = 0
                const scrollValue = window.scrollY

                if ($('body').hasClass('autoscroll')) {
                    return
                }

                if (width <= 1023) {
                    navOffset = 81
                } else if (width < 1215) {
                    navOffset = 140
                } else {
                    navOffset = 161
                }

                // console.log({scrollValue, lastScroll, width, currentScroll, navOffset})

                if (scrollValue >= scrollLimit) {
                    if (currentScroll <= navOffset) {
                        body.classList.remove(scrollUp)
                        body.classList.remove(scrollDown)
                        nav.classList.remove(scrollUpNav)
                        return
                    }
                    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                        // down
                        body.classList.remove(scrollUp)
                        nav.classList.remove(scrollUpNav)
                        body.classList.add(scrollDown)
                    } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
                        // up
                        body.classList.remove(scrollDown)
                        body.classList.add(scrollUp)
                        nav.classList.add(scrollUpNav)
                    }
                    lastScroll = currentScroll
                }
            })
        }
    },
    navbar() {
        $('.navigation')
            .find('.navbar-burger')
            .on('click', function (e) {
                e.preventDefault()
                const target = $(this).attr('data-target')
                const targetObj = $(`#${target}`)
                const object = $('body')
                if (!object.hasClass('menu-open')) {
                    $(object).addClass('menu-open')
                    targetObj.addClass('is-active')
                    // console.log(target, 111);
                } else {
                    $(object).removeClass('menu-open')
                    targetObj.removeClass('is-active')
                    // console.log(target, 222);
                }
            })
    },
    search() {
        $('.search-trigger').on('click', (e) => {
            e.preventDefault()

            $('#search-box').stop().fadeIn(300).addClass('show-it')
            const sTime = setTimeout(() => {
                $('#search-box').find('.input').stop().focus()
            }, 900)
        })
        $('#search-close').on('click', () => {
            // clearTimeout(sTime);
            $('#search-box').stop().fadeOut(300).removeClass('show-it')
            $('#search-box').find('.input').stop().blur()
        })
    },
    lockBg() {
        // lock window position
        document.documentElement.style.overflow = 'hidden'
        document.body.scroll = 'no'
    },
    unlockBg() {
        // unlock window position
        document.documentElement.style.overflow = 'scroll'
        document.body.scroll = 'yes'
    },
    lockScroll() {
        const htmlElement = document.documentElement
        const bodyElement = document.body
        const initWidth = bodyElement.offsetWidth
        const initHeight = bodyElement.offsetHeight

        const scrollPosition = [
            window.pageXOffset || htmlElement.scrollLeft || bodyElement.scrollLeft,
            window.pageYOffset || htmlElement.scrollTop || bodyElement.scrollTop,
        ]
        htmlElement.dataset.scrollPosition = JSON.stringify(scrollPosition)
        htmlElement.dataset.previousOverflow = htmlElement.style.overflow

        htmlElement.style.overflow = 'hidden'
        window.scrollTo(scrollPosition[0], scrollPosition[1])

        const marginR = bodyElement.offsetWidth - initWidth
        const marginB = bodyElement.offsetHeight - initHeight
        bodyElement.style.marginRight = `${marginR}px`
        bodyElement.style.marginBottom = `${marginB}px`
    },
    unlockScroll() {
        const $html = $('html')
        const $body = $('body')
        $html.css('overflow', $html.data('previous-overflow'))
        const scrollPosition = $html.data('scroll-position')
        window.scrollTo(scrollPosition[0], scrollPosition[1])

        $body.css({
            'margin-right': 0,
            'margin-bottom': 0,
        })
    },
    userback() {
        // const cookieValue = document.cookie
        //     .split('; ')
        //     .find((row) => row.startsWith('adminUserGroup='))
        //     ?.split('=')[1]
        // if (cookieValue === 1) {
        // console.log(cookieValue);
        window.Userback = window.Userback || {}
        Userback.access_token = 'P-LJhTw8ud1Ilp1l8P3W2IDliYx';
        (function (d) {
            const s = d.createElement('script')
            s.async = true
            s.src = 'https://static.userback.io/widget/v1.js';
            (d.head || d.body).appendChild(s)
        }(document))
        // }
    },
}

const customWeb = {
    init() {
        this.customSlick()
        this.customClick()
        this.customResize()
        this.customTabindexLoop()
        this.customModalOpen()
        this.customAlertBar()
        this.customParallx()
        this.customDropdown()
        this.customSpanParallx()
        this.customLocomotive()
        this.imageSlick()
    },
    customSpanParallx() {
        const sh = $(window).scrollTop()
        const whHa = $(window).height() / 5
        const isLargeScreen = $(window).width() > 1024
        const isSmallScreen = $(window).width() > 768

        $('.image-and-text h2').each(function () {
            const parallaxH = $(this).offset().top
            if (sh > parallaxH - whHa) {
                const parallaxY = (sh - (parallaxH - whHa)) / 8
                if (isSmallScreen) {
                    $(this).css('transform', ` translate3d(0px, ${parallaxY}px, 0px)`)
                } else {
                    $(this).css('transform', ' translate3d(0px, 0px, 0px)')
                }
            }
        })

        const bannerHeight = $('.banner--home ').innerHeight()
        if (sh < bannerHeight) {
            $('.banner--home .button-group ').addClass('active')
        } else {
            $('.banner--home .button-group ').removeClass('active')
        }
    },
    customLocomotive() {
        const lenis = new Lenis({
            duration: 1.2,
            direction: 'vertical',
        })

        lenis.on('scroll', (e) => {})
        function raf(time) {
            lenis.raf(time)
            requestAnimationFrame(raf)
        }
        requestAnimationFrame(raf)

        window.lenis = lenis
    },
    customParallx() {
        const rellax = new Rellax('.oxley-distinctives .bg-img', {
            center: true,
        })

        $('.oxley-distinctives .bg-img').parallaxie({
            speed: 0.4,
            offset: 0,
            pos_x: 'center',
        })
    },
    customSlickArrow(_self, loop = true) {
        const $controlwrapper = _self.next('.slick-bottom')
        const slickLength = _self.find('.item').length
        _self.on('init', (slick) => {
            if (slickLength > 1) {
                $controlwrapper.find('.slick-arrow').show()
            }
            $controlwrapper.find('.slick-prev').on('click', () => {
                _self.slick('slickPrev')
            })
            $controlwrapper.find('.slick-next').on('click', () => {
                _self.slick('slickNext')
            })
        })

        if (!loop) {
            $controlwrapper.find('.slick-prev').addClass('slick-disabled')
            _self.addClass('unloop')
            _self.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                const slideCount = slick.slideCount

                const slidesToShow = slick.options.slidesToShow
                if (nextSlide === 0) {
                    $controlwrapper.find('.slick-prev').addClass('slick-disabled')
                } else {
                    $controlwrapper.find('.slick-prev').removeClass('slick-disabled')
                }
                if (nextSlide === slideCount - slidesToShow) {
                    $controlwrapper.find('.slick-next').addClass('slick-disabled')
                } else {
                    $controlwrapper.find('.slick-next').removeClass('slick-disabled')
                }
            })
        }
    },
    customSlickCloneActive(_self) {
        _self.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            const slideCount = slick.slideCount
            const $cloneSlides = _self.find('.slick-slide.slick-cloned')
            $cloneSlides.removeClass('slick-clone-current')
            const cloneIndex = nextSlide + slideCount

            $cloneSlides.each(function () {
                if ($(this).data('slick-index') === cloneIndex) {
                    $(this).addClass('slick-clone-current')
                }
            })

            if (nextSlide === slideCount - 1) {
                _self.find('.slick-slide[data-slick-index="-1"]').addClass('slick-clone-current')
            }
        })
    },
    customDropdown() {
        $('.quicklinks .dropdown')
            .find('button')
            .on('click', function () {
                if ($(window).width() < 1024) {
                    $(this).parents('.dropdown').toggleClass('is-active')
                    $(this).parents('.navbar-menu-inner').toggleClass('is-opacity')
                }
            })

        // Update heights on window resize

        $('.quicklinks .dropdown li').on('click', function () {
            const me = $(this)
            if ($(window).width() < 1024) {
                me.parents('.dropdown').removeClass('is-active').find('button').html(me.html())
                me.addClass('is-active').siblings().removeClass('is-active')
                me.parents('.navbar-menu-inner').removeClass('is-opacity')
            }
        })

        $('body').on('click', (e) => {
            const _con = $('.quicklinks .dropdown')
            if (!_con.is(e.target) && _con.has(e.target).length === 0) {
                if ($(window).width() < 1024) {
                    _con.removeClass('is-active')
                    $('.navbar-menu-inner').removeClass('is-opacity')
                }
            }
        })
    },
    customSlick() {
        $('.banner--home .slick').each(function () {
            const _self = $(this)
            const $dotswrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
            const slickLength = _self.find('.slick-item').length
            customWeb.customSlickArrow(_self, false)
            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: false,
                // speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                // autoplay: true,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: true,
            })

            customWeb.customSlickCloneActive(_self)
        })

        $('.image-text-slider .slick').each(function () {
            const _self = $(this)
            const $dotswrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customWeb.customSlickArrow(_self)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                prevArrow: leftArrow,
                nextArrow: rightArrow,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            adaptiveHeight: true,
                        },
                    },
                ],
            })

            customWeb.customSlickCloneActive(_self)
        })

        $('.video-carousel .slick').each(function () {
            const _self = $(this)
            const $dotswrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length
            customWeb.customSlickArrow(_self)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: true,
                prevArrow: leftArrow,
                nextArrow: rightArrow,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: true,
            })

            customWeb.customSlickCloneActive(_self)
        })

        $('.programs .slick').each(function () {
            const _self = $(this)
            const $dotswrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')

            customWeb.customSlickArrow(_self)

            _self.slick({
                dots: false,
                appendDots: $dotswrapper,
                arrows: true,
                prevArrow: leftArrow,
                nextArrow: rightArrow,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: false,
                fade: true,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            })

            customWeb.customSlickCloneActive(_self)
        })

        $('.oxley-distinctives .slick').each(function () {
            const _self = $(this)

            const slickLength = _self.find('.item').length
            customWeb.customSlickArrow(_self)
            _self.slick({
                dots: slickLength > 1,
                arrows: true,
                prevArrow: leftArrow,
                nextArrow: rightArrow,
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 6000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            adaptiveHeight: true,
                        },
                    },
                ],
            })

            customWeb.customSlickCloneActive(_self)
        })
        $('.carousel-with-filtering .slick').each(function () {
            const _self = $(this)
            const slickLength = _self.find('.item').length
            customWeb.customSlickArrow(_self)
            _self.slick({
                dots: slickLength > 1,
                arrows: true,
                prevArrow: leftArrow,
                nextArrow: rightArrow,
                infinite: false,
                // speed: 500,
                slidesToShow: 2,
                slidesToScroll: 1,
                // autoplay: true,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: true,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: false,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: false,
                        },
                    },
                ],
            })

            customWeb.customSlickCloneActive(_self)

            let isSliding = false

            _self.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                isSliding = true
            })

            _self.on('afterChange', (event, slick, currentSlide) => {
                setTimeout(() => {
                    isSliding = false
                }, 100)
            })

            _self.find('.play-video-btn').on('click', () => {})
        })
        $('.cta-and-image-carousel .slick').each(function () {
            const _self = $(this)

            customWeb.customSlickArrow(_self)
            _self.slick({
                dots: false,
                arrows: false,
                prevArrow: leftArrow,
                nextArrow: rightArrow,
                infinite: true,
                // speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                // autoplay: true,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            })

            customWeb.customSlickCloneActive(_self)
        })

        $('.publications-block .slick').each(function () {
            const _self = $(this)

            customWeb.customSlickArrow(_self)
            _self.slick({
                dots: false,
                arrows: true,
                prevArrow: leftArrow,
                nextArrow: rightArrow,
                infinite: false,
                // speed: 500,
                slidesToShow: 4,
                slidesToScroll: 1,
                // autoplay: true,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: true,
                responsive: [
                    {
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            })

            customWeb.customSlickCloneActive(_self)
        })

        $('.full-carousel .slick').each(function () {
            const _self = $(this)
            customWeb.customSlickArrow(_self, false)

            const slickLength = _self.find('.item').length
            if (slickLength < 4) {
                _self.next().hide()
            }
            _self.slick({
                dots: false,
                arrows: false,
                prevArrow: leftArrow,
                nextArrow: rightArrow,
                infinite: false,
                // speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                // autoplay: true,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: true,
                draggable: true,
                responsive: [
                    {
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            })

            customWeb.customSlickCloneActive(_self)
        })
    },

    customClick() {
        $('.navbar-burger').on('click', function (e) {
            e.stopPropagation()
            $(this).toggleClass('active')
        })
        $('.level1 .parent-item.has-children .parent-title').on('click', (e) => {
            e.preventDefault()
        })

        $('.banner--home .icon-play').click(function () {
            $('body').attr('data-lenis-prevent', true)
            $('body,html').addClass('js-overflow-hidden')

            $('.banner--home').addClass('video-full').addClass('transition-delay')
            const $player = $(this).closest('.banner').find('.video-player')
            // digistormWeb.videos.toggleMute($player);

            $('.alert-bar').each(function () {
                const modal = $(this)
                const key = `modal-${modal.data('key')}`
                const cookie = Cookies.get(key)

                if (!cookie) {
                    $('.alert-bar').removeClass('active')
                    $('.alert-bar').addClass('delete')
                    $('#ds-vue-wrapper').removeClass('alert-bar-active').css('margin-top', '0')
                }
            })
        })
        if ($('.carousel-with-filtering ').length) {
            $('.carousel-with-filtering .slicks .item').each(function () {
                const $video = $(this).find('.video-player')
                digistormWeb.videos.pauseVideo($video)
                if ($video.length > 0) {
                    $(this).hover(
                        () => {
                            digistormWeb.videos.playVideo($video)
                        },
                        () => {
                            digistormWeb.videos.pauseVideo($video)
                        },
                    )
                }
            })
        }
        $('.toggle-volume').click(function () {
            const $player = $(this).closest('.banner').find('.video-player')
            digistormWeb.videos.toggleMute($player)

            if (!$(this).hasClass('unmuted')) {
                $(this).addClass('unmuted')
            } else {
                $(this).removeClass('unmuted')
            }
        })
        $('.banner--home .icon-play-close').click(function () {
            $('body').removeAttr('data-lenis-prevent')
            $('body,html').removeClass('js-overflow-hidden')
            $('.banner--home').removeClass('video-full')
            setTimeout(() => {
                $('.banner--home').removeClass('transition-delay')
            }, 1000)
            const $player = $(this).closest('.banner').find('.video-player')

            // digistormWeb.videos.toggleMute($player)

            $('.alert-bar').each(function () {
                const modal1 = $(this)
                const key1 = `modal-${modal1.data('key')}`
                const cookie1 = Cookies.get(key1)

                if (!cookie1) {
                    $('.alert-bar').addClass('active')
                    $('#ds-vue-wrapper').addClass('alert-bar-active').css('margin-top', $('.alert-bar').height())
                    $(window).on('resize', () => {
                        if ($('.alert-bar').hasClass('active')) {
                            $('#ds-vue-wrapper')
                                .addClass('alert-bar-active')
                                .css('margin-top', $('.alert-bar').height())
                        }
                    })
                }
            })
        })

        $('.explore').on('click', function () {
            $('body,html').animate(
                {
                    scrollTop: $(this).parents('.banner').offset().top + $(this).parents().height(),
                },
                500,
            )
        })

        $('.hoz-accordion .item .title-c').on('click', function () {
            const t = $(this).closest('.item')
            if ($(window).width() >= 1024) {
                $(t).toggleClass('is-active').siblings().removeClass('is-active')
            }
        })

        $('.hoz-accordion .item').on('click', function () {
            const t = $(this)
            if ($(window).width() < 1024) {
                $(t).toggleClass('is-active').siblings().removeClass('is-active')
            }
        })

        $('.carousel-with-filtering  .text ul li').on('click', function () {
            const $li = $(this)
            const index = $(this).index()
            const $slick = $(this).parents('.carousel-with-filtering').find('.slick')
            $li.addClass('is-active').siblings().removeClass('is-active')
            $slick.eq(index).addClass('show-in').siblings().removeClass('show-in')
            // $('.day-in-the-life .slick').slick('slickGoTo', $li.index());
        })

        $('.student-journey .item').on('click', function () {
            $(this).toggleClass('is-active').siblings().removeClass('is-active')
            $(this).removeClass('is-height')
            if ($(this).hasClass('is-active')) {
                $(this).siblings().addClass('is-height')
            } else {
                $(this).siblings().removeClass('is-height')
            }
        })
        $('.staff-items .item .item--content').click(function () {
            const $this = $(this).closest('.item')

            $this.addClass('active')
            $this.siblings().removeClass('active')
            $this.parent().siblings().find('.item').removeClass('active')
        })
        $('.item--details .details-close').click(function () {
            $(this).closest('.item').removeClass('active')
        })

        $('.form-input.select input, .form-input.filter input').click(function () {
            $(this).siblings('ul').stop().slideToggle(300)
                .parent()
                .addClass('active')
            $(this).parent().siblings().removeClass('active')
                .find('ul')
                .slideUp()
        })
        $('.form-input.select li, .form-input.filter li').click(function () {
            const text = $(this).text().trim()
            $(this).parent().slideUp()
            $(this).parent().siblings('input').val(text)
            $(this).parents('.form-input').removeClass('active')
        })

        $('.business-listing .list .details-btn').click(function () {
            $(this).toggleClass('active')
            $(this).parents('.wrapper').siblings().stop()
                .slideToggle(300)
        })
        $('body').on('click', (e) => {
            const _menu = $('.navbar-menu-inner')
            if (!_menu.is(e.target) && _menu.has(e.target).length === 0) {
                if ($(window).width() > 1024) {
                    $('.offcanvas-navbar ').removeClass('is-active')
                    $('.navbar-burger ').removeClass('active')
                    $('body').removeClass('menu-open burger-modal-open')
                    $('html').css('overflow', '')
                }
            }

            const _inputSelect = $('.form-input.select')
            if (!_inputSelect.is(e.target) && _inputSelect.has(e.target).length === 0) {
                $('.form-input.select').removeClass('active').find('ul').slideUp()
            }
            const _inputFilter = $('.form-input.filter')
            if (!_inputFilter.is(e.target) && _inputFilter.has(e.target).length === 0) {
                $('.form-input.filter').removeClass('active').find('ul').slideUp()
            }

            const _list = $('.business-listing .list')
            if (!_list.is(e.target) && _list.has(e.target).length === 0) {
                $('.business-listing .list').find('.details-btn').removeClass('active')
                $('.business-listing .list').find('.list--details').slideUp()
            }
        })
    },
    customResize() {
        $('body').attr('style', `--height:${$(window).height()}px`)
        // var stickyHeight = $(window).height()* 1.25  - $(".alert-bar").innerHeight();
        const $alertBar = $('.alert-bar')
        const stickyHeight = $(window).height() - ($alertBar.length ? $alertBar.innerHeight() : 0)
        $('.banner--home').attr('style', `--sticky-height:${stickyHeight}px`)
        $('.banner--campaign').attr('style', `--sticky-height:${stickyHeight}px`)
        $('.carousel-with-filtering  .item').each(function () {
            const $this = $(this)
            const linkHeight = $this.find('.btn-link').length ? $this.find('.btn-link').outerHeight(true) : 0
            const blockquoteHeight = $this.find('.btn-link').length ? $this.find('blockquote').innerHeight() : 0
            const height = blockquoteHeight + linkHeight
            $this.find('.blockquote').attr('style', `--data-height:${height}px`)
        })
        setTimeout(() => {
            $('.btn').each(function () {
                $(this).attr('style', `--left:${Math.ceil($(this).outerWidth(true))}px;`)
            })
        }, 200)

        $('.bottom .quicklinks .dropdown ').each(function () {
            const ulHeight = $(this).find('ul').innerHeight() + 41
            $(this).attr('style', `--data-height:${ulHeight}px`)
        })
        $('.hoz-accordion').attr('style', `--width:${$('.hoz-accordion .item.is-active').width()}px;`)

        const top = $('.publications-block  .img').height() / 2
        const elementHeight = $('.publications-block .slick-prev').innerHeight() / 2
        $('.publications-block .slick-next').css('top', top - 3 * elementHeight)
        $('.publications-block .slick-prev').css('top', top + 1 * elementHeight)

        $('.staff-items .item').each(function () {
            const height = $(this).find('.wrapper').outerHeight(true)
            $(this).find('.item--details').attr('style', `--item-height: ${height}px`)
        })
        if ($('body.homepage').length) {
            $('.navigation .left').addClass('show-in')
            $('.banner--home .text h1').addClass('delay-in-5')
            $('.banner--home .text .button-group').addClass('delay-in-7')
            $('.oxley-distinctives .slick').addClass('delay-in-3')
            $('.oxley-distinctives .text h2').addClass('delay-in-6')
            $('.oxley-distinctives .text .text-box').addClass('delay-in-9')
        }

        const menuHeight = $('.navbar-menu-inner .level1').innerHeight()
        $('.navbar-menu-inner').attr('style', `--menu-height:${menuHeight}px`)
    },
    customTabindexLoop() {
        const $menuItems = $('.left .navbar-logo .logo')
        const $socials = $('.offcanvas-navbar .socials').find('a')
        const $search = $('.left .search-trigger')
        let $focusableElements = $menuItems.add($socials)
        $focusableElements = $focusableElements.add($search)
        // console.log($focusableElements);
        // Function to trap tab within the menu and burger button
        function trapTabKey(e) {
            const $lastFocusableElement = $focusableElements.last()
            const $firstFocusableElement = $focusableElements.eq(1)
            if ($(window).width() >= 1024) {
                const $firstFocusableElement = $focusableElements.first()
            }

            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    // Shift + Tab
                    if ($(document.activeElement).is($firstFocusableElement)) {
                        e.preventDefault()
                        $lastFocusableElement.focus()
                    }
                } else {
                    // Tab
                    if ($(document.activeElement).is($lastFocusableElement)) {
                        e.preventDefault()
                        $firstFocusableElement.focus()
                    }
                }
            }
        }

        // Add event listener to trap Tab key
        $(document).on('keydown', trapTabKey)
    },
    customModalOpen() {
        let flag = 0
        $('.play-video-btn').on('click', () => {
            if (!$('body').hasClass('video-modal-open')) {
                // digistormWeb.lockScroll()
                $('body').attr('data-lenis-prevent', true)
                $('body').addClass('video-modal-open')
                $('html').addClass('video-modal-open')
                flag++
            }
        })
        $('.search-trigger').on('click', () => {
            if (!$('body').hasClass('search-modal-open')) {
                // digistormWeb.lockScroll()
                $('body').attr('data-lenis-prevent', true)
                $('body').addClass('search-modal-open')
                $('html').addClass('video-modal-open')
                flag++
            }
        })
        $('.navbar-burger').on('click', () => {
            if (!$('body').hasClass('burger-modal-open')) {
                // digistormWeb.lockScroll()
                $('body').addClass('burger-modal-open')
                $('html').addClass('video-modal-open')

                flag++
            } else {
                flag -= 1
                $('body').removeClass('burger-modal-open')
                if (flag === 0) {
                    // digistormWeb.unlockScroll()
                    $('html').removeClass('video-modal-open')
                }
            }
        })

        $('.video-modal .modal-background,.video-modal .close-button').on('click', () => {
            flag -= 1
            $('body').removeAttr('data-lenis-prevent')
            $('body').removeClass('video-modal-open')
            $('html').removeClass('video-modal-open')
            if (flag === 0) {
                // digistormWeb.unlockScroll()
                $('html').removeClass('video-modal-open')
            }
        })
        $('#search-close').on('click', () => {
            flag -= 1
            $('body').removeClass('search-modal-open')
            $('body').removeAttr('data-lenis-prevent')
            if (flag === 0) {
                // digistormWeb.unlockScroll()
                $('html').removeClass('video-modal-open')
            }
        })
    },
    customAlertBar() {
        $('.alert-bar').each(function () {
            const modal = $(this)
            const key = `modal-${modal.data('key')}`
            const cookie = Cookies.get(key)

            if (!cookie) {
                modal.addClass('active')
                $('#ds-vue-wrapper').addClass('alert-bar-active').css('margin-top', $('.alert-bar').height())
                // $('.navbar.main-navbar,.side-quicklinks').css("margin-top", $(".alert-bar").height());

                $(window).on('resize', () => {
                    if ($('.alert-bar').hasClass('active')) {
                        $('#ds-vue-wrapper').addClass('alert-bar-active').css('margin-top', $('.alert-bar').height())
                        // $('.navbar.main-navbar,.side-quicklinks').css("margin-top", $(".alert-bar").height());
                    }
                })

                modal.find('.close-alert-bar').click(() => {
                    modal.addClass('delete')
                    $('#ds-vue-wrapper').removeClass('alert-bar-active').css('margin-top', '0')
                    // $('.navbar.main-navbar,.side-quicklinks').css("margin-top", "");
                    Cookies.set(key, 'viewed', {
                        expires: 5,
                    })
                    setTimeout(() => {
                        modal.removeClass('active')
                    }, 300)
                })
                modal.find('.alert-bar-background').click(() => {
                    modal.removeClass('active')
                })
            }
        })
    },

    imageSlick() {
        $('.standard-image-carousel .slick').each(function () {
            const _self = $(this)
            const $dotswrapper = _self.next('.slick-bottom').find('.slick-dots-wrapper')
            const slickLength = _self.find('.item').length

            customWeb.customSlickArrow(_self, false)

            _self.slick({
                dots: slickLength > 1,
                appendDots: $dotswrapper,
                arrows: false,
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                adaptiveHeight: false,
                fade: false,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                focusOnSelect: false,
                draggable: false,
            })
        })

        // lightbox config
        $('.standard-image-carousel')
            .find('.slick')
            .slickLightbox({
                src: 'src',
                itemSelector: 'img',
                caption: 'caption',
                layouts: {
                    closeButton:
                        '<button class="close-modal slick-lightbox-close close-button"> <span></span> <span></span> <span></span> </button>',
                },
            })
    },
}

function initWebsiteScripts() {
    digistormWeb.init()
    $('body').addClass('animated-wowo-control')
    customWeb.init()
}

// wait for vue to mount before attaching event listeners
// any event listeners attached before vue mounts will get deleted
document.addEventListener('ds-components-mounted', (e) => {
    initWebsiteScripts()
})

if (window.dsComponentsMounted) {
    initWebsiteScripts()
}

$(window).scroll(() => {
    digistormWeb.wowo()
    customWeb.customSpanParallx()
})

$(window).on('load', () => {
    digistormWeb.wowo()
    $('a.item button').attr('tabindex', '-1')
})

$(window).on('resize', () => {
    customWeb.customResize()
    customWeb.customSpanParallx()
})

$(window).keydown((event) => {
    if (event.keyCode === 9) {
        $('.level1>li a').focus(function () {
            const me = $(this)
            me.parents('li').addClass('is-active')
            me.parents('li').siblings().removeClass('is-active')
            $('.level1').addClass('is-active')
        })
        $('.level1>li a').blur(function () {
            const me = $(this)
            if (me.parent('[class$=wrapper]').next().length === 0) {
                me.parents('li').removeClass('is-active')
                $('.level1').removeClass('is-active')
            }
        })
    }
})
